import { createRouter, createWebHistory } from 'vue-router'

import BlankMenu from '../layouts/blank-menu/Main.vue'
import EmployeeMenu from '../layouts/employee-menu/Main.vue'
import SideMenu from '../layouts/side-menu/Main.vue'
// import SimpleMenu from '../layouts/simple-menu/Main.vue'
// import TopMenu from '../layouts/top-menu/Main.vue'

import ChooseRole from '../views/login/ChooseRole.vue'

import SuperAdminTools from '../views/superadmin/SuperAdminTools.vue'
import SignUpList from '../views/superadmin/SignUpList.vue'
import SignUpEdit from '../views/superadmin/SignUpEdit.vue'
import SignUpDetail from '../views/superadmin/SignUpDetail.vue'

import NewsList from '../views/news/NewsList.vue'
import NewsAdd from '../views/news/NewsAdd.vue'
import NewsEdit from '../views/news/NewsEdit.vue'
import NewsDetail from '../views/news/NewsDetail.vue'

import Homepage from '../views/home/Home.vue'

import UpdateLoyalty from '../views/loyalty/Update.vue'

import Branches from '../views/branches/List.vue'
import AddBranch from '../views/branches/Add.vue'
import EditBranch from '../views/branches/Edit.vue'
import DetailBranch from '../views/branches/Detail.vue'

import BranchPlaces from '../views/branch-places/List.vue'
import AddBranchPlace from '../views/branch-places/Add.vue'
import EditBranchPlace from '../views/branch-places/Edit.vue'
import DetailBranchPlace from '../views/branch-places/Detail.vue'

import Customers from '../views/customers/List.vue'
import DetailCustomer from '../views/customers/Detail.vue'

import Employees from '../views/employees/List.vue'
import AddEmployee from '../views/employees/Add.vue'
import DetailEmployee from '../views/employees/Detail.vue'
import EditEmployee from '../views/employees/Edit.vue'

import EmployeePlan from '../views/employees/Plan.vue'

import EmployeeAddAccess from '../views/employees/AddAccess.vue'

import AdminEmployeesHome from '../views/admin-employees/AdminEmployeesHome.vue'
import AdminEmployeesCustomerDetail from '../views/admin-employees/AdminEmployeesCustomerDetail.vue'
import AdminEmployeesCustomerList from '../views/admin-employees/AdminEmployeesCustomerList.vue'
import AdminEmployeePlan from '../views/admin-employees/AdminEmployeePlan.vue'

import Admins from '../views/admin-users/List.vue'
import AddAdmin from '../views/admin-users/Add.vue'
import DetailAdmin from '../views/admin-users/Detail.vue'
import EditAdmin from '../views/admin-users/Edit.vue'
import ProfileEdit from '../views/admin-users/ProfileEdit.vue'

import Resources from '../views/resources/List.vue'
import AddResource from '../views/resources/Add.vue'
import EditResource from '../views/resources/Edit.vue'
import DetailResource from '../views/resources/Detail.vue'

import Services from '../views/services/List.vue'
// import AddService from '../views/services/Add.vue'
// import EditService from '../views/services/Edit.vue'
import DetailService from '../views/services/Detail.vue'
import ServiceForm from '@/views/services/ServiceForm.vue'

import Reservations from '../views/reservations/List.vue'

import POSDevices from '../views/pos-devices/POSDeviceList.vue'

import DashboardOverview1 from '../views/dashboard-overview-1/Main.vue'
import DashboardOverview2 from '../views/dashboard-overview-2/Main.vue'
import DashboardOverview3 from '../views/dashboard-overview-3/Main.vue'
import Inbox from '../views/inbox/Main.vue'
import FileManager from '../views/file-manager/Main.vue'
import PointOfSale from '../views/point-of-sale/Main.vue'
import Chat from '../views/chat/Main.vue'
import Post from '../views/post/Main.vue'
import Calendar from '../views/calendar/Main.vue'
import CrudDataList from '../views/crud-data-list/Main.vue'
import CrudForm from '../views/crud-form/Main.vue'
import UsersLayout1 from '../views/users-layout-1/Main.vue'
import UsersLayout2 from '../views/users-layout-2/Main.vue'
import UsersLayout3 from '../views/users-layout-3/Main.vue'
import ProfileOverview1 from '../views/profile-overview-1/Main.vue'
import ProfileOverview2 from '../views/profile-overview-2/Main.vue'
import ProfileOverview3 from '../views/profile-overview-3/Main.vue'
import WizardLayout1 from '../views/wizard-layout-1/Main.vue'
import WizardLayout2 from '../views/wizard-layout-2/Main.vue'
import WizardLayout3 from '../views/wizard-layout-3/Main.vue'
import BlogLayout1 from '../views/blog-layout-1/Main.vue'
import BlogLayout2 from '../views/blog-layout-2/Main.vue'
import BlogLayout3 from '../views/blog-layout-3/Main.vue'
import PricingLayout1 from '../views/pricing-layout-1/Main.vue'
import PricingLayout2 from '../views/pricing-layout-2/Main.vue'
import InvoiceLayout1 from '../views/invoice-layout-1/Main.vue'
import InvoiceLayout2 from '../views/invoice-layout-2/Main.vue'
import FaqLayout1 from '../views/faq-layout-1/Main.vue'
import FaqLayout2 from '../views/faq-layout-2/Main.vue'
import FaqLayout3 from '../views/faq-layout-3/Main.vue'

import Login from '../views/login/Main.vue'
import ForgotPassword from '../views/login/ForgotPassword.vue'
import ForgotPasswordProcess from '../views/login/ForgotPasswordProcess.vue'
import SignUp from '../views/login/SignUp.vue'

// import Register from '../views/register/Main.vue'
import ErrorPage from '../views/error-page/Main.vue'
import UpdateProfile from '../views/update-profile/Main.vue'
import ChangePassword from '../views/change-password/Main.vue'
import RegularTable from '../views/regular-table/Main.vue'
import Tabulator from '../views/tabulator/Main.vue'
import Accordion from '../views/accordion/Main.vue'
import Button from '../views/button/Main.vue'
import Modal from '../views/modal/Main.vue'
import SlideOver from '../views/slide-over/Main.vue'
import Notification from '../views/notification/Main.vue'
import Alert from '../views/alert/Main.vue'
import ProgressBar from '../views/progress-bar/Main.vue'
import Tooltip from '../views/tooltip/Main.vue'
import Dropdown from '../views/dropdown/Main.vue'
import Typography from '../views/typography/Main.vue'
import Icon from '../views/icon/Main.vue'
import LoadingIcon from '../views/loading-icon/Main.vue'
import RegularForm from '../views/regular-form/Main.vue'
import Datepicker from '../views/datepicker/Main.vue'
import TomSelect from '../views/tom-select/Main.vue'
import FileUpload from '../views/file-upload/Main.vue'
import WysiwygEditor from '../views/wysiwyg-editor/Main.vue'
import Validation from '../views/validation/Main.vue'
import Chart from '../views/chart/Main.vue'
import Slider from '../views/slider/Main.vue'
import ImageZoom from '../views/image-zoom/Main.vue'

import Test from '../views/test/Test.vue'

import authService from '@/services/security/auth.service'
import AdvertisementList from '@/views/superadmin/advertisement/AdvertisementList.vue'
import AdvertisementAdd from '@/views/superadmin/advertisement/AdvertisementAdd.vue'
import AdvertisementEdit from '@/views/superadmin/advertisement/AdvertisementEdit.vue'
import AdvertisementDetail from '@/views/superadmin/advertisement/AdvertisementDetail.vue'
import AdvertisementConvert from '@/views/superadmin/advertisement/AdvertisementConvert.vue'

import CategoryList from '@/views/superadmin/category/CategoryList.vue'
import CategoryEdit from '@/views/superadmin/category/CategoryEdit.vue'

const routes = [
  {
    path: '/',
    component: SideMenu,
    children: [
      {
        path: 'testing',
        name: 'side-menu-test',
        component: Test,
        meta: {
          title: 'Home Page - Example App'
        }
      },

      {
        path: '',
        name: 'side-menu-home',
        component: Homepage
      },
      {
        path: 'loyalty',
        name: 'side-menu-loyalty',
        component: UpdateLoyalty
      },
      {
        path: 'services',
        name: 'side-menu-services',
        component: Services
      },
      {
        path: 'services/add',
        name: 'side-menu-services-add',
        component: ServiceForm
      },
      {
        path: 'services/edit/:serviceId',
        name: 'side-menu-services-edit',
        component: ServiceForm,
        props: true
      },
      {
        path: 'services/detail/:uuid',
        name: 'side-menu-services-detail',
        component: DetailService
      },
      {
        path: 'resources',
        name: 'side-menu-resources',
        component: Resources
      },
      {
        path: 'resources/add',
        name: 'side-menu-resources-add',
        component: AddResource
      },
      {
        path: 'resources/edit/:uuid',
        name: 'side-menu-resources-edit',
        component: EditResource
      },
      {
        path: 'resources/detail/:uuid',
        name: 'side-menu-resources-detail',
        component: DetailResource
      },
      {
        path: 'branches',
        name: 'side-menu-branches',
        component: Branches
      },
      {
        path: 'branches/add',
        name: 'side-menu-branches-add',
        component: AddBranch
      },
      {
        path: 'branches/edit/:uuid',
        name: 'side-menu-branches-edit',
        component: EditBranch
      },
      {
        path: 'branches/detail/:uuid',
        name: 'side-menu-branches-detail',
        component: DetailBranch
      },
      {
        path: 'branches/:branchUUID/places',
        name: 'side-menu-branch-places',
        component: BranchPlaces
      },
      {
        path: 'branches/:branchUUID/places/add',
        name: 'side-menu-branch-places-add',
        component: AddBranchPlace
      },
      {
        path: 'branches/:branchUUID/places/detail/:uuid',
        name: 'side-menu-branch-places-detail',
        component: DetailBranchPlace
      },
      {
        path: 'branches/:branchUUID/places/edit/:uuid',
        name: 'side-menu-branch-places-edit',
        component: EditBranchPlace
      },

      {
        path: 'customers',
        name: 'side-menu-customers',
        component: Customers
      },
      {
        path: 'customers/detail/:uuid',
        name: 'side-menu-customers-detail',
        component: DetailCustomer
      },

      {
        path: 'employees',
        name: 'side-menu-employees',
        component: Employees
      },
      {
        path: 'employees/add',
        name: 'side-menu-employees-add',
        component: AddEmployee
      },
      {
        path: 'employees/detail/:uuid',
        name: 'side-menu-employees-detail',
        component: DetailEmployee
      },
      {
        path: 'employees/edit/:uuid',
        name: 'side-menu-employees-edit',
        component: EditEmployee
      },
      {
        path: 'employees/:uuid/plan',
        name: 'side-menu-employees-plan',
        component: EmployeePlan
      },
      {
        path: 'employees/:uuid/add-access',
        name: 'side-menu-employees-add-access',
        component: EmployeeAddAccess
      },

      {
        path: 'admins',
        name: 'admins-list',
        component: Admins
      },
      {
        path: 'admins/add',
        name: 'side-menu-admins-add',
        component: AddAdmin
      },
      {
        path: 'admins/detail/:uuid',
        name: 'side-menu-admins-detail',
        component: DetailAdmin
      },
      {
        path: 'admins/edit/:uuid',
        name: 'side-menu-admins-edit',
        component: EditAdmin
      },
      {
        path: 'admins/profile',
        name: 'admin-profile-edit',
        component: ProfileEdit
      },

      {
        path: 'pos-devices',
        name: 'pos-devices-list',
        component: POSDevices
      },

      // {
      //   path: 'branch-managers',
      //   name: 'branchManagers',
      //   component: Admins
      // },
      // {
      //   path: 'branch-managers/add',
      //   name: 'branchManagersAdd',
      //   component: AddAdmin
      // },
      // {
      //   path: 'branch-managers/detail/:uuid',
      //   name: 'branchManagersDetail',
      //   component: DetailAdmin
      // },
      // {
      //   path: 'branch-managers/edit/:uuid',
      //   name: 'branchManagersEdit',
      //   component: EditAdmin
      // },

      {
        path: 'reservations',
        name: 'side-menu-reservations',
        component: Reservations
      },

      {
        path: 'dashboard-overview-1',
        name: 'side-menu-dashboard-overview-1',
        component: DashboardOverview1
      },
      {
        path: 'dashboard-overview-2',
        name: 'side-menu-dashboard-overview-2',
        component: DashboardOverview2
      },
      {
        path: 'dashboard-overview-3',
        name: 'side-menu-dashboard-overview-3',
        component: DashboardOverview3
      },
      {
        path: 'inbox',
        name: 'side-menu-inbox',
        component: Inbox
      },
      {
        path: 'file-manager',
        name: 'side-menu-file-manager',
        component: FileManager
      },
      {
        path: 'point-of-sale',
        name: 'side-menu-point-of-sale',
        component: PointOfSale
      },
      {
        path: 'chat',
        name: 'side-menu-chat',
        component: Chat
      },
      {
        path: 'post',
        name: 'side-menu-post',
        component: Post
      },
      {
        path: 'calendar',
        name: 'side-menu-calendar',
        component: Calendar
      },
      {
        path: 'crud-data-list',
        name: 'side-menu-crud-data-list',
        component: CrudDataList
      },
      {
        path: 'crud-form',
        name: 'side-menu-crud-form',
        component: CrudForm
      },
      {
        path: 'users-layout-1',
        name: 'side-menu-users-layout-1',
        component: UsersLayout1
      },
      {
        path: 'users-layout-2',
        name: 'side-menu-users-layout-2',
        component: UsersLayout2
      },
      {
        path: 'users-layout-3',
        name: 'side-menu-users-layout-3',
        component: UsersLayout3
      },
      {
        path: 'profile-overview-1',
        name: 'side-menu-profile-overview-1',
        component: ProfileOverview1
      },
      {
        path: 'profile-overview-2',
        name: 'side-menu-profile-overview-2',
        component: ProfileOverview2
      },
      {
        path: 'profile-overview-3',
        name: 'side-menu-profile-overview-3',
        component: ProfileOverview3
      },
      {
        path: 'wizard-layout-1',
        name: 'side-menu-wizard-layout-1',
        component: WizardLayout1
      },
      {
        path: 'wizard-layout-2',
        name: 'side-menu-wizard-layout-2',
        component: WizardLayout2
      },
      {
        path: 'wizard-layout-3',
        name: 'side-menu-wizard-layout-3',
        component: WizardLayout3
      },
      {
        path: 'blog-layout-1',
        name: 'side-menu-blog-layout-1',
        component: BlogLayout1
      },
      {
        path: 'blog-layout-2',
        name: 'side-menu-blog-layout-2',
        component: BlogLayout2
      },
      {
        path: 'blog-layout-3',
        name: 'side-menu-blog-layout-3',
        component: BlogLayout3
      },
      {
        path: 'pricing-layout-1',
        name: 'side-menu-pricing-layout-1',
        component: PricingLayout1
      },
      {
        path: 'pricing-layout-2',
        name: 'side-menu-pricing-layout-2',
        component: PricingLayout2
      },
      {
        path: 'invoice-layout-1',
        name: 'side-menu-invoice-layout-1',
        component: InvoiceLayout1
      },
      {
        path: 'invoice-layout-2',
        name: 'side-menu-invoice-layout-2',
        component: InvoiceLayout2
      },
      {
        path: 'faq-layout-1',
        name: 'side-menu-faq-layout-1',
        component: FaqLayout1
      },
      {
        path: 'faq-layout-2',
        name: 'side-menu-faq-layout-2',
        component: FaqLayout2
      },
      {
        path: 'faq-layout-3',
        name: 'side-menu-faq-layout-3',
        component: FaqLayout3
      },
      {
        path: 'update-profile',
        name: 'side-menu-update-profile',
        component: UpdateProfile
      },
      {
        path: 'change-password',
        name: 'side-menu-change-password',
        component: ChangePassword
      },
      {
        path: 'regular-table',
        name: 'side-menu-regular-table',
        component: RegularTable
      },
      {
        path: 'tabulator',
        name: 'side-menu-tabulator',
        component: Tabulator
      },
      {
        path: 'accordion',
        name: 'side-menu-accordion',
        component: Accordion
      },
      {
        path: 'button',
        name: 'side-menu-button',
        component: Button
      },
      {
        path: 'modal',
        name: 'side-menu-modal',
        component: Modal
      },
      {
        path: 'slide-over',
        name: 'side-menu-slide-over',
        component: SlideOver
      },
      {
        path: 'notification',
        name: 'side-menu-notification',
        component: Notification
      },
      {
        path: 'alert',
        name: 'side-menu-alert',
        component: Alert
      },
      {
        path: 'progress-bar',
        name: 'side-menu-progress-bar',
        component: ProgressBar
      },
      {
        path: 'tooltip',
        name: 'side-menu-tooltip',
        component: Tooltip
      },
      {
        path: 'dropdown',
        name: 'side-menu-dropdown',
        component: Dropdown
      },
      {
        path: 'typography',
        name: 'side-menu-typography',
        component: Typography
      },
      {
        path: 'icon',
        name: 'side-menu-icon',
        component: Icon
      },
      {
        path: 'loading-icon',
        name: 'side-menu-loading-icon',
        component: LoadingIcon
      },
      {
        path: 'regular-form',
        name: 'side-menu-regular-form',
        component: RegularForm
      },
      {
        path: 'datepicker',
        name: 'side-menu-datepicker',
        component: Datepicker
      },
      {
        path: 'tom-select',
        name: 'side-menu-tom-select',
        component: TomSelect
      },
      {
        path: 'file-upload',
        name: 'side-menu-file-upload',
        component: FileUpload
      },
      {
        path: 'wysiwyg-editor',
        name: 'side-menu-wysiwyg-editor',
        component: WysiwygEditor
      },
      {
        path: 'validation',
        name: 'side-menu-validation',
        component: Validation
      },
      {
        path: 'chart',
        name: 'side-menu-chart',
        component: Chart
      },
      {
        path: 'slider',
        name: 'side-menu-slider',
        component: Slider
      },
      {
        path: 'image-zoom',
        name: 'side-menu-image-zoom',
        component: ImageZoom
      }
    ]
  },
  {
    path: '/choose-role',
    component: BlankMenu,
    children: [
      {
        path: '',
        name: 'choose-role',
        component: ChooseRole
      }
    ]
  },
  {
    path: '/superadmin-tools',
    component: BlankMenu,
    children: [
      {
        path: 'user',
        name: 'superadmin-tools-user',
        component: SuperAdminTools
      },
      {
        path: 'sign-up',
        name: 'superadmin-tools-sign-up-list',
        component: SignUpList
      },
      {
        path: 'sign-up/edit/:uuid',
        name: 'superadmin-tools-sign-up-edit',
        component: SignUpEdit
      },
      {
        path: 'sign-up/detail/:uuid',
        name: 'superadmin-tools-sign-up-detail',
        component: SignUpDetail
      },
      {
        path: 'news',
        name: 'superadmin-tools-news',
        component: NewsList
      },
      {
        path: 'news/add',
        name: 'superadmin-tools-news-add',
        component: NewsAdd
      },
      {
        path: 'news/edit/:uuid',
        name: 'superadmin-tools-news-edit',
        component: NewsEdit
      },
      {
        path: 'news/detail/:uuid',
        name: 'superadmin-tools-news-detail',
        component: NewsDetail
      },
      {
        path: 'advertisement',
        name: 'superadmin-tools-advertisement',
        component: AdvertisementList
      },
      {
        path: 'advertisement/add',
        name: 'superadmin-tools-advertisement-add',
        component: AdvertisementAdd
      },
      {
        path: 'advertisement/edit/:uuid',
        name: 'superadmin-tools-advertisement-edit',
        component: AdvertisementEdit
      },
      {
        path: 'advertisement/detail/:uuid',
        name: 'superadmin-tools-advertisement-detail',
        component: AdvertisementDetail
      },
      {
        path: 'advertisement/convert/:uuid',
        name: 'superadmin-tools-advertisement-convert',
        component: AdvertisementConvert
      },
      {
        path: 'category',
        name: 'superadmin-tools-category',
        component: CategoryList
      },
      {
        path: 'category/edit/:uuid/:lang',
        name: 'superadmin-tools-category-edit',
        component: CategoryEdit
      }
    ]
  },
  {
    path: '/pos/employee',
    component: EmployeeMenu,
    children: [
      {
        path: '',
        name: 'admin-employees-home',
        component: AdminEmployeesHome
      },
      {
        path: 'plan',
        name: 'admin-employees-plan',
        component: AdminEmployeePlan
      },
      {
        path: 'customers',
        name: 'admin-employees-customers',
        component: AdminEmployeesCustomerList
      },
      {
        path: 'customers/:uuid',
        name: 'admin-employees-customers-detail',
        component: AdminEmployeesCustomerDetail
      }
    ]
  },
  // {
  //   path: '/simple-menu',
  //   component: SimpleMenu,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'simple-menu-dashboard-overview-1',
  //       component: DashboardOverview1
  //     },
  //     {
  //       path: 'dashboard-overview-2',
  //       name: 'simple-menu-dashboard-overview-2',
  //       component: DashboardOverview2
  //     },
  //     {
  //       path: 'dashboard-overview-3',
  //       name: 'simple-menu-dashboard-overview-3',
  //       component: DashboardOverview3
  //     },
  //     {
  //       path: 'inbox',
  //       name: 'simple-menu-inbox',
  //       component: Inbox
  //     },
  //     {
  //       path: 'file-manager',
  //       name: 'simple-menu-file-manager',
  //       component: FileManager
  //     },
  //     {
  //       path: 'point-of-sale',
  //       name: 'simple-menu-point-of-sale',
  //       component: PointOfSale
  //     },
  //     {
  //       path: 'chat',
  //       name: 'simple-menu-chat',
  //       component: Chat
  //     },
  //     {
  //       path: 'post',
  //       name: 'simple-menu-post',
  //       component: Post
  //     },
  //     {
  //       path: 'calendar',
  //       name: 'simple-menu-calendar',
  //       component: Calendar
  //     },
  //     {
  //       path: 'crud-data-list',
  //       name: 'simple-menu-crud-data-list',
  //       component: CrudDataList
  //     },
  //     {
  //       path: 'crud-form',
  //       name: 'simple-menu-crud-form',
  //       component: CrudForm
  //     },
  //     {
  //       path: 'users-layout-1',
  //       name: 'simple-menu-users-layout-1',
  //       component: UsersLayout1
  //     },
  //     {
  //       path: 'users-layout-2',
  //       name: 'simple-menu-users-layout-2',
  //       component: UsersLayout2
  //     },
  //     {
  //       path: 'users-layout-3',
  //       name: 'simple-menu-users-layout-3',
  //       component: UsersLayout3
  //     },
  //     {
  //       path: 'profile-overview-1',
  //       name: 'simple-menu-profile-overview-1',
  //       component: ProfileOverview1
  //     },
  //     {
  //       path: 'profile-overview-2',
  //       name: 'simple-menu-profile-overview-2',
  //       component: ProfileOverview2
  //     },
  //     {
  //       path: 'profile-overview-3',
  //       name: 'simple-menu-profile-overview-3',
  //       component: ProfileOverview3
  //     },
  //     {
  //       path: 'wizard-layout-1',
  //       name: 'simple-menu-wizard-layout-1',
  //       component: WizardLayout1
  //     },
  //     {
  //       path: 'wizard-layout-2',
  //       name: 'simple-menu-wizard-layout-2',
  //       component: WizardLayout2
  //     },
  //     {
  //       path: 'wizard-layout-3',
  //       name: 'simple-menu-wizard-layout-3',
  //       component: WizardLayout3
  //     },
  //     {
  //       path: 'blog-layout-1',
  //       name: 'simple-menu-blog-layout-1',
  //       component: BlogLayout1
  //     },
  //     {
  //       path: 'blog-layout-2',
  //       name: 'simple-menu-blog-layout-2',
  //       component: BlogLayout2
  //     },
  //     {
  //       path: 'blog-layout-3',
  //       name: 'simple-menu-blog-layout-3',
  //       component: BlogLayout3
  //     },
  //     {
  //       path: 'pricing-layout-1',
  //       name: 'simple-menu-pricing-layout-1',
  //       component: PricingLayout1
  //     },
  //     {
  //       path: 'pricing-layout-2',
  //       name: 'simple-menu-pricing-layout-2',
  //       component: PricingLayout2
  //     },
  //     {
  //       path: 'invoice-layout-1',
  //       name: 'simple-menu-invoice-layout-1',
  //       component: InvoiceLayout1
  //     },
  //     {
  //       path: 'invoice-layout-2',
  //       name: 'simple-menu-invoice-layout-2',
  //       component: InvoiceLayout2
  //     },
  //     {
  //       path: 'faq-layout-1',
  //       name: 'simple-menu-faq-layout-1',
  //       component: FaqLayout1
  //     },
  //     {
  //       path: 'faq-layout-2',
  //       name: 'simple-menu-faq-layout-2',
  //       component: FaqLayout2
  //     },
  //     {
  //       path: 'faq-layout-3',
  //       name: 'simple-menu-faq-layout-3',
  //       component: FaqLayout3
  //     },
  //     {
  //       path: 'update-profile',
  //       name: 'simple-menu-update-profile',
  //       component: UpdateProfile
  //     },
  //     {
  //       path: 'change-password',
  //       name: 'simple-menu-change-password',
  //       component: ChangePassword
  //     },
  //     {
  //       path: 'regular-table',
  //       name: 'simple-menu-regular-table',
  //       component: RegularTable
  //     },
  //     {
  //       path: 'tabulator',
  //       name: 'simple-menu-tabulator',
  //       component: Tabulator
  //     },
  //     {
  //       path: 'accordion',
  //       name: 'simple-menu-accordion',
  //       component: Accordion
  //     },
  //     {
  //       path: 'button',
  //       name: 'simple-menu-button',
  //       component: Button
  //     },
  //     {
  //       path: 'modal',
  //       name: 'simple-menu-modal',
  //       component: Modal
  //     },
  //     {
  //       path: 'slide-over',
  //       name: 'simple-menu-slide-over',
  //       component: SlideOver
  //     },
  //     {
  //       path: 'notification',
  //       name: 'simple-menu-notification',
  //       component: Notification
  //     },
  //     {
  //       path: 'alert',
  //       name: 'simple-menu-alert',
  //       component: Alert
  //     },
  //     {
  //       path: 'progress-bar',
  //       name: 'simple-menu-progress-bar',
  //       component: ProgressBar
  //     },
  //     {
  //       path: 'tooltip',
  //       name: 'simple-menu-tooltip',
  //       component: Tooltip
  //     },
  //     {
  //       path: 'dropdown',
  //       name: 'simple-menu-dropdown',
  //       component: Dropdown
  //     },
  //     {
  //       path: 'typography',
  //       name: 'simple-menu-typography',
  //       component: Typography
  //     },
  //     {
  //       path: 'icon',
  //       name: 'simple-menu-icon',
  //       component: Icon
  //     },
  //     {
  //       path: 'loading-icon',
  //       name: 'simple-menu-loading-icon',
  //       component: LoadingIcon
  //     },
  //     {
  //       path: 'regular-form',
  //       name: 'simple-menu-regular-form',
  //       component: RegularForm
  //     },
  //     {
  //       path: 'datepicker',
  //       name: 'simple-menu-datepicker',
  //       component: Datepicker
  //     },
  //     {
  //       path: 'tom-select',
  //       name: 'simple-menu-tom-select',
  //       component: TomSelect
  //     },
  //     {
  //       path: 'file-upload',
  //       name: 'simple-menu-file-upload',
  //       component: FileUpload
  //     },
  //     {
  //       path: 'wysiwyg-editor',
  //       name: 'simple-menu-wysiwyg-editor',
  //       component: WysiwygEditor
  //     },
  //     {
  //       path: 'validation',
  //       name: 'simple-menu-validation',
  //       component: Validation
  //     },
  //     {
  //       path: 'chart',
  //       name: 'simple-menu-chart',
  //       component: Chart
  //     },
  //     {
  //       path: 'slider',
  //       name: 'simple-menu-slider',
  //       component: Slider
  //     },
  //     {
  //       path: 'image-zoom',
  //       name: 'simple-menu-image-zoom',
  //       component: ImageZoom
  //     }
  //   ]
  // },
  // // {
  //   path: '/top-menu',
  //   component: TopMenu,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'top-menu-dashboard-overview-1',
  //       component: DashboardOverview1
  //     },
  //     {
  //       path: 'dashboard-overview-2',
  //       name: 'top-menu-dashboard-overview-2',
  //       component: DashboardOverview2
  //     },
  //     {
  //       path: 'dashboard-overview-3',
  //       name: 'top-menu-dashboard-overview-3',
  //       component: DashboardOverview3
  //     },
  //     {
  //       path: 'inbox',
  //       name: 'top-menu-inbox',
  //       component: Inbox
  //     },
  //     {
  //       path: 'file-manager',
  //       name: 'top-menu-file-manager',
  //       component: FileManager
  //     },
  //     {
  //       path: 'point-of-sale',
  //       name: 'top-menu-point-of-sale',
  //       component: PointOfSale
  //     },
  //     {
  //       path: 'chat',
  //       name: 'top-menu-chat',
  //       component: Chat
  //     },
  //     {
  //       path: 'post',
  //       name: 'top-menu-post',
  //       component: Post
  //     },
  //     {
  //       path: 'calendar',
  //       name: 'top-menu-calendar',
  //       component: Calendar
  //     },
  //     {
  //       path: 'crud-data-list',
  //       name: 'top-menu-crud-data-list',
  //       component: CrudDataList
  //     },
  //     {
  //       path: 'crud-form',
  //       name: 'top-menu-crud-form',
  //       component: CrudForm
  //     },
  //     {
  //       path: 'users-layout-1',
  //       name: 'top-menu-users-layout-1',
  //       component: UsersLayout1
  //     },
  //     {
  //       path: 'users-layout-2',
  //       name: 'top-menu-users-layout-2',
  //       component: UsersLayout2
  //     },
  //     {
  //       path: 'users-layout-3',
  //       name: 'top-menu-users-layout-3',
  //       component: UsersLayout3
  //     },
  //     {
  //       path: 'profile-overview-1',
  //       name: 'top-menu-profile-overview-1',
  //       component: ProfileOverview1
  //     },
  //     {
  //       path: 'profile-overview-2',
  //       name: 'top-menu-profile-overview-2',
  //       component: ProfileOverview2
  //     },
  //     {
  //       path: 'profile-overview-3',
  //       name: 'top-menu-profile-overview-3',
  //       component: ProfileOverview3
  //     },
  //     {
  //       path: 'wizard-layout-1',
  //       name: 'top-menu-wizard-layout-1',
  //       component: WizardLayout1
  //     },
  //     {
  //       path: 'wizard-layout-2',
  //       name: 'top-menu-wizard-layout-2',
  //       component: WizardLayout2
  //     },
  //     {
  //       path: 'wizard-layout-3',
  //       name: 'top-menu-wizard-layout-3',
  //       component: WizardLayout3
  //     },
  //     {
  //       path: 'blog-layout-1',
  //       name: 'top-menu-blog-layout-1',
  //       component: BlogLayout1
  //     },
  //     {
  //       path: 'blog-layout-2',
  //       name: 'top-menu-blog-layout-2',
  //       component: BlogLayout2
  //     },
  //     {
  //       path: 'blog-layout-3',
  //       name: 'top-menu-blog-layout-3',
  //       component: BlogLayout3
  //     },
  //     {
  //       path: 'pricing-layout-1',
  //       name: 'top-menu-pricing-layout-1',
  //       component: PricingLayout1
  //     },
  //     {
  //       path: 'pricing-layout-2',
  //       name: 'top-menu-pricing-layout-2',
  //       component: PricingLayout2
  //     },
  //     {
  //       path: 'invoice-layout-1',
  //       name: 'top-menu-invoice-layout-1',
  //       component: InvoiceLayout1
  //     },
  //     {
  //       path: 'invoice-layout-2',
  //       name: 'top-menu-invoice-layout-2',
  //       component: InvoiceLayout2
  //     },
  //     {
  //       path: 'faq-layout-1',
  //       name: 'top-menu-faq-layout-1',
  //       component: FaqLayout1
  //     },
  //     {
  //       path: 'faq-layout-2',
  //       name: 'top-menu-faq-layout-2',
  //       component: FaqLayout2
  //     },
  //     {
  //       path: 'faq-layout-3',
  //       name: 'top-menu-faq-layout-3',
  //       component: FaqLayout3
  //     },
  //     {
  //       path: 'update-profile',
  //       name: 'top-menu-update-profile',
  //       component: UpdateProfile
  //     },
  //     {
  //       path: 'change-password',
  //       name: 'top-menu-change-password',
  //       component: ChangePassword
  //     },
  //     {
  //       path: 'regular-table',
  //       name: 'top-menu-regular-table',
  //       component: RegularTable
  //     },
  //     {
  //       path: 'tabulator',
  //       name: 'top-menu-tabulator',
  //       component: Tabulator
  //     },
  //     {
  //       path: 'accordion',
  //       name: 'top-menu-accordion',
  //       component: Accordion
  //     },
  //     {
  //       path: 'button',
  //       name: 'top-menu-button',
  //       component: Button
  //     },
  //     {
  //       path: 'modal',
  //       name: 'top-menu-modal',
  //       component: Modal
  //     },
  //     {
  //       path: 'slide-over',
  //       name: 'top-menu-slide-over',
  //       component: SlideOver
  //     },
  //     {
  //       path: 'notification',
  //       name: 'top-menu-notification',
  //       component: Notification
  //     },
  //     {
  //       path: 'alert',
  //       name: 'top-menu-alert',
  //       component: Alert
  //     },
  //     {
  //       path: 'progress-bar',
  //       name: 'top-menu-progress-bar',
  //       component: ProgressBar
  //     },
  //     {
  //       path: 'tooltip',
  //       name: 'top-menu-tooltip',
  //       component: Tooltip
  //     },
  //     {
  //       path: 'dropdown',
  //       name: 'top-menu-dropdown',
  //       component: Dropdown
  //     },
  //     {
  //       path: 'typography',
  //       name: 'top-menu-typography',
  //       component: Typography
  //     },
  //     {
  //       path: 'icon',
  //       name: 'top-menu-icon',
  //       component: Icon
  //     },
  //     {
  //       path: 'loading-icon',
  //       name: 'top-menu-loading-icon',
  //       component: LoadingIcon
  //     },
  //     {
  //       path: 'regular-form',
  //       name: 'top-menu-regular-form',
  //       component: RegularForm
  //     },
  //     {
  //       path: 'datepicker',
  //       name: 'top-menu-datepicker',
  //       component: Datepicker
  //     },
  //     {
  //       path: 'tom-select',
  //       name: 'top-menu-tom-select',
  //       component: TomSelect
  //     },
  //     {
  //       path: 'file-upload',
  //       name: 'top-menu-file-upload',
  //       component: FileUpload
  //     },
  //     {
  //       path: 'wysiwyg-editor',
  //       name: 'top-menu-wysiwyg-editor',
  //       component: WysiwygEditor
  //     },
  //     {
  //       path: 'validation',
  //       name: 'top-menu-validation',
  //       component: Validation
  //     },
  //     {
  //       path: 'chart',
  //       name: 'top-menu-chart',
  //       component: Chart
  //     },
  //     {
  //       path: 'slider',
  //       name: 'top-menu-slider',
  //       component: Slider
  //     },
  //     {
  //       path: 'image-zoom',
  //       name: 'top-menu-image-zoom',
  //       component: ImageZoom
  //     }
  //   ]
  // },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/forgot-password-process/:userUUID/:token',
    name: 'forgot-password-process',
    component: ForgotPasswordProcess
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUp
  },
  {
    path: '/error-page',
    name: 'error-page',
    component: ErrorPage
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  }
})

function startsWithAny(str, prefixes) {
  return prefixes.some(prefix => str.startsWith(prefix))
}

router.beforeEach((to, from, next) => {
  const publicPages = [
    'login',
    'forgot-password',
    'forgot-password-process',
    'sign-up'
  ]
  const editorPages = [
    'superadmin-tools-news'//,
    // 'superadmin-tools-advertisement'
  ]
  const authPages = [
    'choose-role'
  ]
  const authRequired = !publicPages.includes(to.name)
  const authCommon = !authPages.includes(to.name)
  const authSuperAdmin = to.name.startsWith('superadmin-tools')
  const authEditor = startsWithAny(to.name, editorPages)
  const loggedIn = localStorage.getItem('auth_user')
  const userValidity = localStorage.getItem('auth_user_validity')
  const manager = localStorage.getItem('auth_role_manager')
  const employee = localStorage.getItem('auth_role_employee')
  const superadmin = localStorage.getItem('auth_superadmin')
  const editor = localStorage.getItem('auth_editor')

  if (!authRequired) {
    next()
    return
  }

  if (!loggedIn || !userValidity) {
    next('/login')
    return
  }

  function isValidUUID(uuid) {
    if (uuid === null || typeof uuid === 'undefined') {
      return false
    }

    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    return uuidRegex.test(uuid)
  }

  const now = new Date()
  if (parseInt(userValidity) < now.setSeconds(now.getSeconds())) {
    authService.refreshToken().then(function (result) {
      if (result) {
        next()
        return
      }
      authService.logout()
      next('/login')
    })
    return
  }

  if (authSuperAdmin && superadmin === 'true') {
    next()
    return
  }

  if (authEditor && editor === 'true') {
    next()
    return
  }

  if (to.name === 'choose-role' && editor === 'true') {
    next('/superadmin-tools/news')
    return
  }

  if (authCommon && !isValidUUID(manager) && !isValidUUID(employee)) {
    next('/choose-role')
    return
  }

  next()
})

export default router
